import * as tslib_1 from "tslib";
import reduceResourceSource from './resourceSource';
import reduceResourceStore from './resourceStore';
import { reduceResourceEntityExpansions } from './resourceEntityExpansions';
export default function (state, action, calendar) {
    var resourceSource = reduceResourceSource(state.resourceSource, action, state.dateProfile, calendar);
    var resourceStore = reduceResourceStore(state.resourceStore, action, resourceSource, calendar);
    var resourceEntityExpansions = reduceResourceEntityExpansions(state.resourceEntityExpansions, action);
    return tslib_1.__assign({}, state, { resourceSource: resourceSource,
        resourceStore: resourceStore,
        resourceEntityExpansions: resourceEntityExpansions });
}
